document.addEventListener("DOMContentLoaded", function () {
  var frameSizeInput = document.getElementById("frame-size");
  var elements = {
    S: document.getElementById("S"),
    M: document.getElementById("M"),
    L: document.getElementById("L"),
    XL: document.getElementById("XL"),
  };

  frameSizeInput.addEventListener("input", function () {
    var inputValue = parseFloat(frameSizeInput.value);

    if ((inputValue <= 125 && inputValue > 10) || inputValue <= 4.9) {
      elements.S.classList.add("bg-gray-200");
    } else {
      elements.S.classList.remove("bg-gray-200");
    }

    if (
      (inputValue >= 126 && inputValue <= 130) ||
      (inputValue >= 5 && inputValue <= 5.1)
    ) {
      elements.M.classList.add("bg-gray-200");
    } else {
      elements.M.classList.remove("bg-gray-200");
    }

    if (
      (inputValue >= 131 && inputValue <= 135) ||
      (inputValue >= 5.2 && inputValue <= 5.3)
    ) {
      elements.L.classList.add("bg-gray-200");
    } else {
      elements.L.classList.remove("bg-gray-200");
    }

    if (inputValue > 135 || (inputValue > 5.3 && inputValue < 10)) {
      elements.XL.classList.add("bg-gray-200");
    } else {
      elements.XL.classList.remove("bg-gray-200");
    }
  });
});
